import { Box, Typography, Container, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { Close, Check, Shield, Lock } from '@mui/icons-material';

const NoGatekeepers = () => {
  return (
    <Box sx={{ py: 15, background: '#0B0B0B', position: 'relative', overflow: 'hidden' }}>
      {/* Animated Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '10%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(200,169,107,0.05) 0%, transparent 70%)',
          borderRadius: '50%',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '10%',
          right: '5%',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(200,169,107,0.05) 0%, transparent 70%)',
          borderRadius: '50%',
        }}
      />

      <Container maxWidth="lg">
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Typography
                variant="subtitle1"
                sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2 }}
              >
                UNIQUE SELLING POINT
              </Typography>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '4rem' },
                  mb: 4,
                  fontWeight: 800,
                  lineHeight: 1.2,
                }}
              >
                NO NUMBER{" "}
                <Box component="span" sx={{ color: '#C8A96B' }}>
                  FIVE
                </Box>{" "}
                HERE
              </Typography>

              <Typography variant="body1" sx={{ color: '#ccc', mb: 4, fontSize: '1.1rem' }}>
                In soccer, the Number-5 jersey is a defensive position — designed to stop access.
                In corporate business, gatekeepers, receptionists, and protocol officers create
                the same barriers.
              </Typography>

              <Typography variant="body1" sx={{ color: '#C8A96B', mb: 3, fontWeight: 600 }}>
                NOT HERE. You have direct access to achieve your goal.
              </Typography>

              <Button
                variant="contained"
                href="/contact"
                sx={{
                  background: '#C8A96B',
                  color: '#000',
                  px: 5,
                  py: 1.5,
                  fontSize: '1.1rem',
                  '&:hover': { background: '#D6B57B' },
                }}
              >
                Access Directly
              </Button>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Box
                sx={{
                  background: '#111',
                  borderRadius: 4,
                  p: 5,
                  border: '1px solid rgba(200,169,107,0.2)',
                }}
              >
                <Typography variant="h5" sx={{ mb: 3, color: '#C8A96B' }}>
                  Direct Access Promise
                </Typography>

                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Check sx={{ color: '#4CAF50' }} />
                  <Typography>No receptionist screening</Typography>
                </Box>
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Check sx={{ color: '#4CAF50' }} />
                  <Typography>No executive secretaries</Typography>
                </Box>
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Check sx={{ color: '#4CAF50' }} />
                  <Typography>No protocol restrictions</Typography>
                </Box>
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Check sx={{ color: '#4CAF50' }} />
                  <Typography>Direct WhatsApp, Email, and meeting access</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Check sx={{ color: '#4CAF50' }} />
                  <Typography>3-business day response guarantee</Typography>
                </Box>

                <Box
                  sx={{
                    mt: 4,
                    p: 3,
                    background: 'rgba(200,169,107,0.1)',
                    borderRadius: 2,
                    textAlign: 'center',
                  }}
                >
                  <Typography sx={{ fontSize: '0.9rem', color: '#C8A96B' }}>
                    "Everyone worldwide has access and opportunity to communicate
                    directly with John Pierre Asfar."
                  </Typography>
                </Box>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NoGatekeepers;